import {REQUEST_TYPE} from '../../../constants';
import {doRequest} from '../../../helpers/network';
import {Finance} from '../../../helpers/Urls';

const INITIAL_STATE = {
  npcApprovals: null,
  npcApprovalsLoading: false,
  npcApprovalsError: null,
};

export const NPC_APPROVALS_LOADING = 'NPC_APPROVALS_LOADING';
export const FETCH_NPC_APPROVALS_COMPLETED = 'FETCH_NPC_APPROVALS_COMPLETED';
export const NPC_APPROVALS_ERROR = 'NPC_APPROVALS_ERROR';

// Fetch NPC change-request approval queue (GET /finance/npc-approvals/).
// Supports pagination + status filter.
export const fetchNpcApprovals = (params = {}) => async (dispatch) => {
  dispatch({type: NPC_APPROVALS_LOADING});

  const {page = 1, status} = params;
  const query = [`page=${page}`, status ? `status=${status}` : '']
    .filter(Boolean)
    .join('&');

  try {
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.fetchNpcApprovalsURL(query),
    });

    // The API returns the paginated object with `npc_records` at the top level.
    // Some endpoints wrap it as {status, data}; support both shapes.
    const payload =
      response && response.npc_records ? response : response && response.data;

    if (payload && payload.npc_records) {
      dispatch({type: FETCH_NPC_APPROVALS_COMPLETED, payload});
      return {success: true, data: payload};
    }
    dispatch({
      type: NPC_APPROVALS_ERROR,
      error: (response && response.message) || 'Failed to fetch NPC approvals',
    });
    return {success: false, message: response && response.message};
  } catch (err) {
    dispatch({type: NPC_APPROVALS_ERROR, error: err});
    return {success: false, message: err?.message || 'Unexpected error'};
  }
};

// Approve a change request (POST /v2/finance/npc-approvals/{id}/approve/)
export const approveNpcRequest = (npcRecordId, payload) => async () => {
  try {
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.approveNpcRequestURL(npcRecordId),
      data: payload,
    });
    const {status, message} = response || {};
    if (status) {
      return {success: true, data: response.data, message};
    }
    return {success: false, message: message || 'Failed to approve request'};
  } catch (err) {
    return {
      success: false,
      message:
        err?.response?.data?.message || err?.message || 'Something went wrong',
    };
  }
};

// Reject a change request (POST /v2/finance/npc-approvals/{id}/reject/)
export const rejectNpcRequest = (npcRecordId, payload) => async () => {
  try {
    const response = await doRequest({
      method: REQUEST_TYPE.POST,
      url: Finance.rejectNpcRequestURL(npcRecordId),
      data: payload,
    });
    const {status, message} = response || {};
    if (status) {
      return {success: true, data: response.data, message};
    }
    return {success: false, message: message || 'Failed to reject request'};
  } catch (err) {
    return {
      success: false,
      message:
        err?.response?.data?.message || err?.message || 'Something went wrong',
    };
  }
};

// Reducer
export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};

  switch (type) {
    case NPC_APPROVALS_LOADING:
      return {...state, npcApprovalsLoading: true, npcApprovalsError: null};

    case FETCH_NPC_APPROVALS_COMPLETED:
      return {
        ...state,
        npcApprovalsLoading: false,
        npcApprovals: payload,
      };

    case NPC_APPROVALS_ERROR:
      return {
        ...state,
        npcApprovalsLoading: false,
        npcApprovalsError: action.error,
      };

    default:
      return state;
  }
};
